// extracted by mini-css-extract-plugin
export default {"SkiContents":"SkiContents_SkiContents__PNM-C","OneContent":"SkiContents_OneContent__cS7jv"};